export type AppMode = "development" | "staging" | "production";

type EnvConfig = {
  mode: AppMode;
  apiBaseUrl: string;
  appName: string;
};

const MODE_CONFIG: Record<AppMode, Omit<EnvConfig, "mode" | "appName">> = {
  development: {
    apiBaseUrl: "http://localhost:8000/api",
  },
  staging: {
    apiBaseUrl: "https://uat-api.fincobox.com/api",
  },
  production: {
    apiBaseUrl: "https://api.fincobox.com/api",
  },
};

function resolveMode(raw: string): AppMode {
  if (raw === "staging" || raw === "production" || raw === "development") {
    return raw;
  }
  return "development";
}

const mode = resolveMode(import.meta.env.MODE);
const defaults = MODE_CONFIG[mode];

export const env: EnvConfig = {
  mode,
  appName: "Fincobox Partner",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? defaults.apiBaseUrl,
};

export const isProd = mode === "production";
